export default "__VITE_ASSET__Dpzkgzju__"